export const SET_PASSAGE = "SET_PASSAGE";
export const SET_CURRENT_PASSAGE_ID = "SET_CURRENT_PASSAGE_ID";
export const SET_PASSAGE_TEST = "SET_PASSAGE_TEST";
export const CHANGE_PASSAGE_TEST = "CHANGE_PASSAGE_TEST";
export const SET_TEST_PASSAGE_ID = "SET_TEST_PASSAGE_ID";
export const SET_CONTINUED_LESSON_ID = "SET_CONTINUED_LESSON_ID";
